// extracted by mini-css-extract-plugin
export var honor_img = "index-module--honor_img--5527c";
export var honor_part = "index-module--honor_part--8f5f0";